module.exports = __webpack_public_path__ + "static/media/logo.7c57cb82.png";